import { EmojiCombobox } from '@udecode/plate';

export const emojiPlugin = {
  renderAfterEditable: EmojiCombobox,
};
